import { apiRootUrl, coreApiRootUrl } from '../config.local';
import AuthenticationResult from '../models/be/AuthenticationResult';
import { SsoCustomer } from '../models/be/SsoCustomer';
import SsoClientCredentials from '../models/be/transport/SsoClientCredentials';

export async function getSsoCustomersByDomain(domain: string): Promise<SsoCustomer[]> {
	const headers = {
		'Content-Type': 'application/json'
	};

	const response = await fetch(`${coreApiRootUrl}/v1/ssocustomers/${domain}`, { headers });
	if (!response.ok) {
		throw new Error(`Request failed with status: ${response.status}`);
	}
	const data = await response.json();
	return data;
}

export async function getSsoClientToken(credentials: SsoClientCredentials): Promise<AuthenticationResult> {
	const headers = {
		'Content-Type': 'application/json'
	};
	const body = JSON.stringify(credentials);
	const response = await fetch(`${apiRootUrl}/api/Authentication/sso`, {
		method: 'POST',
		headers,
		body
	});

	if (!response.ok) {
		throw new Error(`Request failed with status: ${response.status}`);
	}
	const data = await response.json();
	return data;
}
